import request from '@/utils/request'


// 查询视频打赏记录列表
export function listRewardLog(query) {
  return request({
    url: '/video/reward/log/list',
    method: 'get',
    params: query
  })
}

// 查询视频打赏记录分页
export function pageRewardLog(query) {
  return request({
    url: '/video/reward/log/page',
    method: 'get',
    params: query
  })
}

// 查询视频打赏记录详细
export function getRewardLog(data) {
  return request({
    url: '/video/reward/log/detail',
    method: 'get',
    params: data
  })
}

// 新增视频打赏记录
export function addRewardLog(data) {
  return request({
    url: '/video/reward/log/add',
    method: 'post',
    data: data
  })
}

// 修改视频打赏记录
export function updateRewardLog(data) {
  return request({
    url: '/video/reward/log/edit',
    method: 'post',
    data: data
  })
}

// 删除视频打赏记录
export function delRewardLog(data) {
  return request({
    url: '/video/reward/log/delete',
    method: 'post',
    data: data
  })
}
